module.exports = __webpack_public_path__ + "platform/piivo-logo-connexion.svg";